export enum DocumentType {
  Softcopy = "Softcopy",
  Hardcopy = "Hardcopy",
}

export namespace DocumentType {
  export function toId(status: DocumentType): string {
    switch (status) {
      case DocumentType.Softcopy:
        return "DT230000001";
      case DocumentType.Hardcopy:
        return "DT230000002";
      default:
        return "";
    }
  }
}
